import React from "react";
import { DocumentLibrary } from "@/components/customer/DocumentLibrary";

export default function Manuals() {
  return (
    <DocumentLibrary
      overline="Knowledge Base"
      title="User Manuals"
      subtitle="Owner's manuals, appliance guides and technical documentation approved for On The Move caravan owners."
      docType="manual"
      emptyHint="Your OTM administrator can publish manuals here for customers to download."
    />
  );
}
